import React, { useState, useEffect } from 'react';
import { Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import Login from './components/Login';
import SnippetList from './components/SnippetList';
import SnippetDetails from './components/SnippetDetails';
import CreateSnippet from './components/CreateSnippet';
import AddUser from './components/AddUser';
import api, { setLogoutHandler } from './axios';

const App = () => {
  return <AppContent />;
};

const AppContent = () => {
  const navigate = useNavigate();
  const [isLoggedIn, setIsLoggedIn] = useState(!!localStorage.getItem('access_token'));
  const [isAdmin, setIsAdmin] = useState(JSON.parse(localStorage.getItem('is_admin')) || false);
  const [showAddUser, setShowAddUser] = useState(false);
  const [isCreatingSnippet, setIsCreatingSnippet] = useState(false);
  const [snippets, setSnippets] = useState([]);
  const [selectedSnippetId, setSelectedSnippetId] = useState(null);

  useEffect(() => {
    if (isLoggedIn) {
      fetchSnippets();
    }
  }, [isLoggedIn]);

  const handleLoginSuccess = (isAdmin) => {
    setIsLoggedIn(true);
    setIsAdmin(isAdmin);
    localStorage.setItem('is_admin', JSON.stringify(isAdmin));
    fetchSnippets();

    navigate('/');
  };

  const fetchSnippets = async () => {
    try {
      const response = await api.get('/api/snippets');
      setSnippets(response.data.snippets);
    } catch (error) {
      console.error('Error fetching snippets:', error);
    }
  };

  const handleLogout = async () => {
    try {
      await api.delete('/api/logout');
      await api.delete('/api/logout-refresh');
    } catch (error) {
      console.error('Logout failed:', error);
    }

    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('is_admin');

    setIsLoggedIn(false);
    navigate('/login');
  };

  const handleForcedLogout = () => {
    console.warn("🔴 Session expired, logging out...");

    // Clear tokens
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('is_admin');

    setIsLoggedIn(false);

    // ✅ Force navigation to login
    navigate('/login', { replace: true });
  };

  return (
    <Routes>
      <Route path="/login" element={<Login onLoginSuccess={handleLoginSuccess} />} />
      <Route
        path="/"
        element={
          isLoggedIn ? (
            showAddUser ? (
              <AddUser onCancel={() => setShowAddUser(false)} />
            ) : (
              <div className="header"
		style={{
    		  backgroundColor: '#E5E7E9',
    		  //border: '1px solid #36454F',
    		  //padding: '6px 10px',
    		  //borderRadius: '4px',
		  //borderBottom: '2px solid #5D6D7E',
    		  color: '#36454F'
  		}}>

                <div style={{ position: 'sticky', top: 0, zIndex: 1000, 
			padding: '10px', 
			boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)', 
			borderBottom: '1px solid #5D6D7E', }}>
                  <button onClick={handleLogout} style={{ margin: '10px', padding: '5px 10px' }}>Logout</button>
                  <button onClick={() => setIsCreatingSnippet(true)} style={{ margin: '10px', padding: '5px 10px' }}>+ New Snippet</button>
                  {isAdmin && <button onClick={() => setShowAddUser(true)} style={{ margin: '10px', padding: '5px 10px' }}>Add User</button>}
                </div>

                <div style={{ display: 'flex', height: 'calc(100vh - 70px)'}}>
                  <div style={{ width: '30%', borderRight: '1px solid #ccc', overflowY: 'auto' }}>
                    <SnippetList onSnippetSelect={setSelectedSnippetId} />
                  </div>
                  <div style={{ flex: 1, padding: '10px', overflowY: 'auto' }}>
                    {isCreatingSnippet ? (
                      <CreateSnippet
                        onSnippetCreated={(newSnippet) => {
                          setSnippets((prevSnippets) => [newSnippet, ...prevSnippets]);
                          setIsCreatingSnippet(false);
                          setSelectedSnippetId(newSnippet.id);
                          fetchSnippets();
                        }}
                        onCancel={() => setIsCreatingSnippet(false)}
                      />
                    ) : (
                      <SnippetDetails snippetId={selectedSnippetId} />
                    )}
                  </div>
                </div>
              </div>
            )
          ) : (
            <Navigate to="/login" />
          )
        }
      />
    </Routes>
  );
};

export default App;
